import { TimeFilter } from '../enums/time-fileter.enum';

/**
 * Generates a filename for statistics download in the format:
 * "propertyDisplayName-MM-DD-YYYY-filterDuration"
 * @param propertyDisplayName - The display name of the property
 * @param filter - The time filter applied
 * @returns The generated filename with USA date format (MM-DD-YYYY)
 */
export function generateStatsFilename(propertyDisplayName: string, filter: TimeFilter): string {
  // Get current date in MM-DD-YYYY format (USA format, filesystem-safe)
  const now = new Date();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const year = now.getFullYear();
  const date = `${month}-${day}-${year}`;

  // Clean property display name (remove special characters, replace spaces with hyphens)
  const cleanDisplayName = propertyDisplayName
    .replace(/[^a-zA-Z0-9\s]/g, '') // Remove special characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .toLowerCase();

  // Convert filter to a clean duration string
  const filterDuration = filter.toLowerCase().replace(/\s+/g, '-'); // Replace spaces with hyphens

  return `${cleanDisplayName}-${date}-${filterDuration}.xlsx`;
}
